import { useLocation } from '@common/location-layer/composables/useLocation'

/**
 * Location initialization plugin - shared across all apps
 * Initializes location store on server side. When SSR cannot resolve the host
 * (e.g. health-check, prerender, or hook-timing failure), useLocation now returns
 * null and leaves the store empty — this plugin runs again on the client tick
 * (mode: 'all') and the !hasLocation guard inside initLocation triggers a real
 * client-side fetch with window.location.hostname.
 */
export default defineNuxtPlugin(async () => {
  try {
    const { initLocation, store } = useLocation()
    // Initialize the location store
    await initLocation()

    // Diagnostic only — surfaces the rare "neither SSR nor client could populate
    // the store" case to anyone tailing logs. Not a fatal condition.
    if (process.client && !store.hasLocation) {
      console.warn('[Init-Location] location data still empty after init; portal branding may be missing')
    }
  } catch (error) {
    // Never block app start due to bootstrap; log for diagnostics
    console.error('[Init-Location] Location initialization failed:', error)
  }
})
